import { render, staticRenderFns } from "./ErrorBadge.vue?vue&type=template&id=68b4cc98&"
import script from "./ErrorBadge.vue?vue&type=script&lang=js&"
export * from "./ErrorBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports